<template>
  <v-dialog
    persistent
    overlay-opacity="0.6"
    max-width="800"
    :value="openDialog"
  >
    <!-- @input is required to emit emit input if clicked outside unless we use persistent -->
    <v-container fill-height fluid grid-list-xl>
      <v-layout justify-center wrap>
        <v-flex md12>
          <base-material-card class="pa-0 " color="primary">
            <template v-slot:heading>
              <v-row class="pa-0">
                <v-col
                  align="center"
                  class="pa-0 card-title-text"
                  style="font-size: 25px"
                  >{{ $t("editorial-set-category-title") }}</v-col
                >
                <v-col cols="1" class="pa-0"
                  ><v-icon @click="closeDialog" large>mdi-close</v-icon></v-col
                >
              </v-row>
            </template>
            <v-card-text>
              <span v-if="!fetchingCategories">{{
                $t("editorial-set-category-text")
              }}</span>
              <v-select
                item-text="name"
                item-value="id"
                :items="categories"
                v-if="!fetchingCategories"
                outlined
                dense
                v-model="item_category_id"
              />
              <v-progress-circular
                v-if="fetchingCategories"
                :indeterminate="true"
                :rotate="0"
                :size="32"
                :width="4"
                color="light-blue"
              ></v-progress-circular>
            </v-card-text>
            <v-btn
              :disabled="fetchingCategories"
              width="120"
              @click="confirm()"
              color="primary"
              >{{ $t("msgbox-ok") }}</v-btn
            >
            <v-btn
              :disabled="fetchingCategories"
              width="120"
              @click="dismiss()"
              color="secondary"
              >{{ $t("msgbox-cancel") }}</v-btn
            >
          </base-material-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-dialog>
</template>

<script>
import editorialManager from "../../apis/editorial";

export default {
  data() {
    return {
      categories: [],
      openDialog: false,
      dialogResolve: null,
      dialogReject: null,
      fetchingCategories: false,
      item_category_id: null
    };
  },

  methods: {
    show(nation_id, category_id) {
      return new Promise((resolve, reject) => {
        this.value = true;
        this.item_category_id = category_id;
        this.dialogResolve = resolve;
        this.dialogReject = reject;
        this.openDialog = true;
        this.fetchingCategories = true;
        editorialManager
          .fetchCategories(nation_id)
          .then(res => {
            this.categories = [
              { id: null, name: this.$t("gbl-none-female") },
              ...res
            ];
            this.fetchingCategories = false;
          })
          .catch(err => {
            this.fetchingCategories = false;
            console.log(err);
          });
      });
    },

    hide() {
      this.openDialog = false;
      this.dialogReject();
    },

    confirm() {
      this.openDialog = false;
      this.dialogResolve(this.item_category_id);
    },

    dismiss() {
      this.hide();
    },

    closeDialog() {
      this.hide();
    }
  }
};
</script>
